import React, { useState } from 'react';
import { TransactionDetailsDialog } from 'components';
import { NoData } from 'components/NoData';
import TransactionView from 'components/TransactionList/transaction-view';
import useAddress from 'hooks/use-address';
import useSafe from 'hooks/use-safe';
import { isEmpty } from 'lodash';
import { IMultisigTransaction } from 'utils/transform-multisig-transaction';

import { ActivityTableHeader } from './ActivityTableHeader';

type Props = {
  transactionsHistory: IMultisigTransaction[];
};

// TODO_Y: [PN]
// TODO_R: [RCC]
export const History = ({ transactionsHistory }: Props) => {
  const { safe } = useSafe();
  const address = useAddress() || '';
  const [historyTransaction, setHistoryTransaction] = useState<string | null>(null);

  if (isEmpty(transactionsHistory)) return <NoData />;

  return (
    <>
      <ActivityTableHeader />
      {transactionsHistory
        .sort((a, b) => {
          const dateA = new Date(a.create_time).getTime();
          const dateB = new Date(b.create_time).getTime();

          return dateB - dateA;
        })
        .map((t) => (
          <div
            key={t._id}
            onClick={(e) => {
              e.stopPropagation();
              setHistoryTransaction(t._id);
            }}
          >
            <div className="z-0">
              <TransactionView
                transaction={t}
                readOnly={!safe.owners.find((o) => o.address === address)}
              />
            </div>
          </div>
        ))}
      {historyTransaction && (
        <TransactionDetailsDialog
          transactionId={historyTransaction}
          onClose={() => {
            setHistoryTransaction(null);
          }}
        />
      )}
    </>
  );
};
